import { useProfile } from './useProfile';

export const useIsApprover = (): boolean | undefined => {
  const { profile, loading } = useProfile();

  if (loading) return;

  if (!profile) return false;

  return (
    profile.role.includes('approver') ||
    profile.isSequentialApprover ||
    profile.adminOrganizations.length > 0
  );
};
